import React from 'react';
import { Bill } from '../../../models/Factura';
import Select from '../../Forms/Select';
import { GLOBAL_MES, GLOBAL_PERIODO_OPT, globalAnoOptions } from '../constants/factura.options';

interface FacturaGlobalProps {
    global: Bill['global'];
    onGlobalChange: (property: 'periodo' | 'mes' | 'ano') => (value: any) => void;
}

function FacturaGlobal({ global, onGlobalChange }: FacturaGlobalProps) {
    return (
        <div className={`global ${global ? '' : 'hidden'}`}>
            <h4>Publico en General o Global</h4>
            <div className="card table">
                <div className="cardBody">
                    <div className="row three lg-two xxs-one cfdiBase xs-gap-compressed">
                        <Select label="Periodo" value={global?.periodo || '01'} onChange={onGlobalChange('periodo')} placeholder="Rango de tiempo para venta mostrador" options={GLOBAL_PERIODO_OPT} disabled={!global} />
                    </div>
                    <div className="row three lg-two xxs-one cfdiBase xs-gap-compressed">
                        <Select label="Año" value={global?.ano || ''} onChange={onGlobalChange('ano')} placeholder="Año" options={globalAnoOptions()} disabled={!global} />
                        <Select label="Mes" value={global?.mes || '05'} onChange={onGlobalChange('mes')} placeholder="Mes" options={GLOBAL_MES} disabled={!global} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FacturaGlobal;
